












































































































import checkbox from '@/form/Checkbox.vue'
import clientList from '@/components/ClientList.vue'
import datefield from '@/form/Datefield.vue'
import editor from '@/form/Editor.vue'
import halson from '@/services/HALSONResource.coffee'
import miniFabButton from '@/elements/MiniFabButton.vue'
import moment from 'moment'
import multi_checkbox from '@/form/MultiCheckbox.vue'
import q from 'q'
import radiobutton from '@/form/RadioButton.vue'
import radiobuttonGroup from '@/form/RadioButtonGroup.vue'
import spinner from '@/elements/Spinner.vue'
import textfield from '@/form/Textfield.vue'
import transferDom from '@/directives/transferDom.vue'
import urlTemplate from 'url-template'
import Vue from 'vue'
import { mapState } from 'vuex'
import { sprintf } from 'sprintf-js'

# halson from 'halson'
import * as _ from 'lodash'

export default {
  name: 'ClientForm'

  data: () ->
      debug: false
      email: null
      min_year: moment().year() - 85
      max_year: moment().year() - 18
      client: { id: null }
      props: {}
      original_props: {}
      props_url_tmpl: null
      id_is_invalid: false
      year_is_invalid: false

  components:
    'v-field': datefield
    'v-textfield': textfield
    'v-datefield': datefield
    'v-radiobutton': radiobutton
    'v-radiobutton-group': radiobuttonGroup
    'v-checkbox': checkbox
    'v-multi_checkbox': multi_checkbox
    'v-editor' : editor
    'v-client-list': clientList
    'v-fab-button': miniFabButton

  directives:
    'transfer-dom': transferDom

  methods:
    toggleDebug: ->
      @$validator.validateAll().then (result) ->
        console.log 'validation: ', result
      @debug = !@debug

    resetProps: ->
      for group in @groups.getEmbeds 'client_property_groups'
        for prop in group.getEmbeds 'client_property_definition'
          @$set @props, prop.uid, null

    checkYear: ->
      @year_is_invalid = isNaN(@client.year) || @client.year < @min_year || @client.year > @max_year

    saveClient: (client) ->
      await @$store.dispatch 'saveClient', [client, @original_props]
      componentHandler.upgradeElements @$el
      @$emit 'message', 'Sparad...'

    newClient: () ->
      @$store.dispatch 'newClient'
      @$nextTick () =>
        @$refs['first_tab'].click()
        componentHandler.upgradeElements @$el

    getPropertyValue: (uid) ->
      idx = _.findIndex @client.getEmbeds('client_property'), ['property_uid', uid]
      if idx == -1
        @client.addEmbed 'client_property', @newProperty(@client.uid, uid)
        null
      else
        @client.getEmbeds('client_property')[idx].value

    setPropertyValue: (uid, value) ->
      console.log uid, value
      prop = @client.getEmbed 'client_property',
        (embed) ->
          embed.property_uid == uid
      @$set prop, 'value', value

    newProperty: (client_uid, property_uid) ->
      prop = halson
        client_uid: client_uid
        property_uid: property_uid
        value: null

      url = @props_url_tmpl.expand
          client_id: client_uid
          prop_id: property_uid

      prop.addLink('self', url)

  created: () ->
    @client = _.cloneDeep @selected_client

    if not @are_loaded.resources then await @$store.dispatch 'getServices'
    @props_url_tmpl = urlTemplate.parse(@$store.getters.resourceURL('client_property.get'))

    if not @are_loaded.groups
      await @$store.dispatch 'getGroups'

    @resetProps()

  mounted: () ->
    componentHandler.upgradeElements @$el

  beforeDestroy: ()->
    componentHandler.downgradeElements @$el

  watch:
    selected_client: (item) ->
      if @selected_client?
        @client = _.cloneDeep @selected_client

        for group in @groups.getEmbeds 'client_property_groups'
          for prop in group.getEmbeds 'client_property_definition'
            @props[prop.uid] = @getPropertyValue(prop.uid)

        @original_props = _.clone @props

        @$validator.validateAll()

    'client.id': (id) ->
      ok = await @$store.dispatch 'checkClientId',
        uid: @client.uid
        id: id

      if ok then @id_is_invalid = false else @id_is_invalid = true

  computed:
    mapState
      selected_client: (state) ->
        state.selected_client
      isLoading: (state) ->
        state.xhr_is_loading
      groups: (state) ->
        state.cprop_groups
      resources: (state) ->
        state.resources
      are_loaded: (state) ->
        state.are_loaded

}




// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/pages/ClientForm.vue